import React, { lazy, Suspense } from "react";

const LazyListBranch = lazy(() => import("./ListBranch"));
const LazyGetAgentByBranch = lazy(() => import("./GetAgentByBranch"));
const LazyEditBranch = lazy(() => import("./EditBranch"));

export const ListBranch = () => (
  <Suspense fallback="loading...">
    <LazyListBranch />
  </Suspense>
);
export const GetAgentByBranch = () => (
  <Suspense fallback="loading...">
    <LazyGetAgentByBranch />
  </Suspense>
);
export const EditBranch = () => (
  <Suspense fallback="loading...">
    <LazyEditBranch />
  </Suspense>
);
